import { t } from "adapters/i18n";
import transformerUtils from "shared/transformerUtils";
import type { Retiro, Retreat } from "shared/types";
import type { DataResult, ServiceConstructor } from "../services.types";

export function RetreatServiceMixin<TBase extends ServiceConstructor>(
  Base: TBase
) {
  return class RetreatService extends Base {
    readonly retreatUrl = `${process.env.REACT_APP_ENDPOINT}pastos/api/v1/retiros`;

    async listRetreatsForFarm(
      farmId: number | number[]
    ): Promise<DataResult<Retreat>> {
      try {
        const plainFilter = {
          where: { IdFazenda: Array.isArray(farmId) ? farmId : [farmId] },
        };

        const filter = this.montaFiltro(plainFilter);
        const url = this.montaURL(this.retreatUrl, filter);
        const result = await this.get(url);

        if (result.data == null) {
          return { data: [], total: 0 };
        }

        const retreats = (result.data as Retiro[]).map((item) =>
          transformerUtils.toRetreat(item)
        );

        const total = retreats.length;

        return { data: retreats, total };
      } catch (_) {
        throw new Error(t("locales:fetch-farm-retreats-error"));
      }
    }
  };
}
